export type NurionLinkKind = "board-card" | "meet-room" | "drive-file";

export interface NurionLink {
  kind: NurionLinkKind;
  product: "Board" | "Meet" | "Drive";
  label: "Card" | "Join call" | "File";
}

const RESERVED_MEET_SEGMENTS = new Set<string>([
  "skills",
  "pricing",
  "login",
  "signup",
  "about",
  "legal",
  "privacy",
  "terms",
  "manage",
]);

export function parseNurionLink(href: string): NurionLink | null {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }

  if (url.protocol !== "https:") return null;
  if (url.port !== "") return null;

  const segments = url.pathname.split("/").filter(Boolean);

  switch (url.hostname) {
    case "board.nurion.com":
      if (segments.length === 4 && segments[0] === "board" && segments[2] === "card") {
        return { kind: "board-card", product: "Board", label: "Card" };
      }
      return null;

    case "meet.nurion.com": {
      const first = segments[0];
      if (first && !RESERVED_MEET_SEGMENTS.has(first.toLowerCase())) {
        return { kind: "meet-room", product: "Meet", label: "Join call" };
      }
      return null;
    }

    case "docs.nurion.com":
      if (segments.length === 3 && segments[0] === "drive" && segments[1] === "d") {
        return { kind: "drive-file", product: "Drive", label: "File" };
      }
      return null;

    default:
      return null;
  }
}
